import { create } from 'zustand';
import { endpoints } from '../api/api';

export const useChatStore = create((set, get) => ({
    sessions: [],
    currentSessionId: null,
    messages: {}, // sessionId -> Message[]
    loading: false,
    historyLoading: false,

    // Actions
    loadSessions: async (userId) => {
        set({ historyLoading: true });
        try {
            const response = await endpoints.chat.getSessions(userId);
            set({ sessions: response.data, historyLoading: false });
        } catch (error) {
            console.error('Failed to load sessions:', error);
            set({ historyLoading: false });
        }
    },

    getTodaySession: async (userId) => {
        try {
            const response = await endpoints.chat.getTodaySession(userId);
            const session = response.data;
            set(state => ({
                sessions: [session, ...state.sessions.filter(s => s.id !== session.id)],
                currentSessionId: session.id
            }));
            return session;
        } catch (error) {
            console.error('Failed to get today session:', error);
        }
    },

    loadMessages: async (sessionId) => {
        if (!sessionId) return;

        // Check if messages already loaded? (Optional optimization)
        // For now, always reload to get latest
        try {
            const response = await endpoints.chat.getMessages(sessionId);
            set(state => ({
                messages: {
                    ...state.messages,
                    [sessionId]: response.data
                }
            }));
        } catch (error) {
            console.error('Failed to load messages:', error);
        }
    },

    setCurrentSession: (sessionId) => {
        set({ currentSessionId: sessionId });
        get().loadMessages(sessionId);
    },

    createNewSession: async (userId) => {
        try {
            const response = await endpoints.chat.createSession({ user_id: userId, title: "New Chat" });
            const session = response.data;
            set(state => ({
                sessions: [session, ...state.sessions],
                currentSessionId: session.id,
                messages: { ...state.messages, [session.id]: [] }
            }));
            return session;
        } catch (error) {
            console.error("Failed to create session", error);
        }
    },

    // Optimistic message adding
    addMessageToStore: (sessionId, message) => {
        set(state => ({
            messages: {
                ...state.messages,
                [sessionId]: [...(state.messages[sessionId] || []), message]
            }
        }));
    },

    updateSessionTitle: async (sessionId, title) => {
        try {
            await endpoints.chat.updateSession(sessionId, { title });
            set(state => ({
                sessions: state.sessions.map(s => s.id === sessionId ? { ...s, title } : s)
            }));
        } catch (error) {
            console.error("Failed to update title", error);
        }
    },

    archiveSession: async (sessionId) => {
        try {
            await endpoints.chat.deleteSession(sessionId);
            set(state => ({
                sessions: state.sessions.filter(s => s.id !== sessionId),
                currentSessionId: state.currentSessionId === sessionId ? null : state.currentSessionId
            }));
        } catch (error) {
            console.error("Failed to archive", error);
        }
    }

}));
